import * as React from 'react';

import { PropertyHostProfile } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';

interface PropertyHostProfileProps extends SharedUiWrapperProps {
  columns?: number;
}

const PropertyHostProfileWrapper: React.FC<PropertyHostProfileProps> = ({ inputs, columns }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <RefTarget name="Host" tabIndex={0}>
      <SimpleLazyLoadWrapper>
        <PropertyHostProfile inputs={inputs} columns={columns} />
      </SimpleLazyLoadWrapper>
    </RefTarget>
  </UitkSpacing>
);

export const SharedUiPropertyHostProfileWrapper = withSharedUiPropertyDetails(PropertyHostProfileWrapper);
SharedUiPropertyHostProfileWrapper.displayName = 'SharedUiPropertyHostProfileWrapper';
